import React, { HTMLAttributes, ReactNode, useEffect, useState } from 'react';
import { ILearningCenterCategory } from '../../../../../../types/contentful';
import Link from '../../../../Link';
import { getCategorySlug } from '../../shared';

interface ArticleLinkProps extends HTMLAttributes<HTMLAnchorElement> {
  children: ReactNode;
  category?: ILearningCenterCategory;
  slug?: string;
  goToLCPage?: boolean;
}

function setLink(
  category?: ILearningCenterCategory,
  slug?: string,
  goToLearningCenter = true
) {
  if (!slug) {
    return '/';
  }

  if (!category) {
    category = {
      fields: {
        slug: 'investing',
        name: 'Investing'
      }
    } as any;
  }

  const categorySlug = getCategorySlug(category);

  return goToLearningCenter
    ? `/learning-center/${categorySlug}/${slug}`
    : `/partner-resources/${categorySlug}/${slug}`;
}

export function ArticleLink({
  category,
  slug,
  children,
  goToLCPage,
  ...props
}: ArticleLinkProps) {
  const [articleUrl, setArticleUrl] = useState(
    setLink(category, slug, goToLCPage)
  );

  useEffect(() => {
    setArticleUrl(setLink(category, slug, goToLCPage));
  }, [category, slug]);

  return (
    <Link href={articleUrl} {...props}>
      {children}
    </Link>
  );
}
